// import firebaseAxios from '@/shared/firebase/firebase-axios';
/* eslint-disable */
import logService from '@/shared/entity-logger';
import { db, firebase } from '@/shared/firebase/firebase-init';
import _ from 'underscore'
import teamModel from '../../team/team-model';

// PATH
const KEY_TEAMS_PER_GROUP = 'teamsPerGroup'
const KEY_TEAMS = 'teams'
const KEY_GAMES_PER_GROUP = 'gamesPerGroup'
const KEY_GAMES = 'games'

const NAME_ENTITY = 'tournament'

export default {

  saveGroup(groupModel, loggedUser) {
    const modelToSave = {
      isClose: false,
      name: groupModel.name,
      teamList: groupModel.teamList,
      id: db.ref(KEY_TEAMS_PER_GROUP).push().key,
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      var updates = {};
      updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + modelToSave.id] = modelToSave;

      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          logService.log(modelToSave, "created", KEY_TEAMS_PER_GROUP, NAME_ENTITY)
          resolve()
        }
      });
    })
  },

  closeGroup(groupModel, loggedUser) {
    const modelToSave = {
      ... groupModel,
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      var updates = {};
      updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + groupModel.id + '/isClose'] = true;

      db.ref().update(updates, (error) => {
        if (error) {
          reject(error)
        } else {
          logService.log(modelToSave, "close", KEY_TEAMS_PER_GROUP, NAME_ENTITY)
          resolve()
        }
      });
    })
  },

   openGroup(groupModel, loggedUser) {
    const modelToSave = {
      ... groupModel,
      modified: firebase.database.ServerValue.TIMESTAMP,
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      var updates = {};
      updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + groupModel.id + '/isClose'] = false;

      db.ref().update(updates, (error) => {
        if (error) {
          reject(error)
        } else {
          logService.log(modelToSave, "close", KEY_TEAMS_PER_GROUP, NAME_ENTITY)
          resolve()
        }
      });
    })
  },

  listGroup(categoryId) {
    return new Promise((resolve) => {
      db.ref(KEY_TEAMS_PER_GROUP).child(categoryId).once('value').then((snapshot) => {
        const list = []
        snapshot.forEach(childSnapshot => {
          var teamList = []

          if (!_.isEmpty(childSnapshot.val().teams)) {
            _.each(childSnapshot.val().teams, (team) => {
              teamList.push(team)
            })
          }
          
          console.log(teamList);
          
          var grooupModel = {
            name: childSnapshot.val().name,
            isClose: childSnapshot.val().isClose,
            teamList: teamList,
            categoryId: categoryId,
            id:  childSnapshot.val().id
          } 

          list.push(grooupModel)
        });
        resolve(list)
      });
    });
  },

  destroyGroup(groupModel, loggedUser) {
    const modelToDestroy = {
      ...groupModel,
      modified: firebase.database.ServerValue.TIMESTAMP,
      deleted: firebase.database.ServerValue.TIMESTAMP,
      deletedBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };
    return new Promise((resolve, reject) => {

      if (_.size(groupModel.teamList) > 0) {
        reject(new Error("El grupo tiene equipos asignados."))
      } else {
        var updates = {};
        updates['/' + KEY_TEAMS_PER_GROUP + '/' + groupModel.categoryId + '/' + groupModel.id ] = null;

        db.ref().update(updates, (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            logService.log(modelToDestroy, "deleted", KEY_TEAMS_PER_GROUP, NAME_ENTITY)
            resolve()
          }
        })
      }
    })
  },

  addTeam(model, loggedUser) {
    const modelToSave = {
      ...teamModel.forSimple(model.team),
      created: firebase.database.ServerValue.TIMESTAMP,
      modified: firebase.database.ServerValue.TIMESTAMP,
      createdBy: { id: loggedUser.id, email: loggedUser.email },
      modifiedBy: { id: loggedUser.id, email: loggedUser.email }
    };

    return new Promise((resolve, reject) => {
      var updates = {};


      if ( model.from.groupId !== "" ) {
        updates['/' + KEY_TEAMS_PER_GROUP + '/' + model.categoryId + '/' + model.from.groupId + '/' + KEY_TEAMS + '/' +  model.team.id] = null;
      }

      if ( model.to.groupId !== "" ) {
        updates['/' + KEY_TEAMS_PER_GROUP + '/' + model.categoryId + '/' + model.to.groupId + '/' + KEY_TEAMS + '/' +  model.team.id] = modelToSave;
        updates[ KEY_TEAMS + '/' +  model.team.id + '/hasGroup'] = true;
      } else {
        updates[ KEY_TEAMS + '/' +  model.team.id + '/hasGroup'] = false;
      }

      // Si muevo de un grupo  a la lista de equipos sin asignar, hasGroup=false
      // 
      
      db.ref().update(updates, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          logService.log(modelToSave, "add team", KEY_TEAMS_PER_GROUP, NAME_ENTITY)
          resolve()
        }
      });
    })
  },

  generateMatches(modelGroup, loggedUser){
      // delete teamTotalList[indexA];
    return new Promise((resolve, reject) => {
      var updates = {};

      const teamList = modelGroup.teamList
      const teamTotalList = modelGroup.teamList
      const games = []
        
      for (var indexA = 0; indexA < teamList.length; indexA++) {
        for (var indexB = indexA + 1; indexB < teamList.length; indexB++) {
          console.log("<********teamList.length", teamList.length); 
          console.log("<***************** A ", indexA); 
          console.log("<***************** B ", indexB); 

          const gameModelToSave = {
            id: db.ref().push().key, 
            teamLocal: teamModel.forGame(teamList[indexA]),
            teamAway: teamModel.forGame(teamList[indexB]),
            created: firebase.database.ServerValue.TIMESTAMP,
            modified: firebase.database.ServerValue.TIMESTAMP,
            createdBy: { id: loggedUser.id, email: loggedUser.email },
            modifiedBy: { id: loggedUser.id, email: loggedUser.email },
            finally: false,
            place: '',
            date: '',
            referre: ''
          };
          
          console.log("<*****************");
          // console.log(gameModelToSave);
          
          updates['/' + KEY_GAMES_PER_GROUP + '/' + modelGroup.categoryId + '/' + modelGroup.id + '/' + KEY_GAMES + '/' +  gameModelToSave.id] = gameModelToSave;
          updates['/' + KEY_GAMES + '/' + gameModelToSave.id] = gameModelToSave;

          if (indexA == teamList.length - 2) {
            db.ref().update(updates, (error) => {
              if (error) {
                // The write failed...
                reject(error)
              } else {
                console.log('FIIIIIIINNNNNN');
                
                // Data saved successfully!
                // logService.log(modelToSave, "add games", KEY_TEAMS_PER_GROUP, NAME_ENTITY)
                resolve()
              }
            });
          }
        }
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/entities/tournament/setting-groups/setting-groups-service.js